import React, { useState } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import './Contact.css';

function Contact() {
  const [headerRef, headerVisible] = useScrollReveal();
  const [formRef, formVisible] = useScrollReveal();
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState(null); // 'sending' | 'success' | 'error'

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('https://p7010.greenaurem.org/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error('Request failed');
      setStatus('success');
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="contact__container">
        <div
          ref={headerRef}
          className={`contact__header reveal ${headerVisible ? 'reveal--visible' : ''}`}
        >
          <h2 className="section-title">Kontakta Hafize Cetin Konsult</h2>
          <p className="section-subtitle">
            Hör gärna av dig för frågor, samarbete eller bokning av föreläsning
          </p>
        </div>

        <div
          ref={formRef}
          className={`contact__content reveal ${formVisible ? 'reveal--visible' : ''}`}
          style={{ transitionDelay: '0.1s' }}
        >
          <div className="contact__info">
            <div className="contact__info-card">
              <div className="contact__info-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <div>
                <p className="contact__info-label">E-post</p>
                <a href="mailto:hafize.basak@hotmail.com" className="contact__info-value">
                  hafize.basak@hotmail.com
                </a>
              </div>
            </div>
          </div>

          <form className="contact__form" onSubmit={handleSubmit}>
            <div className="contact__form-row">
              <div className="contact__field">
                <label>Namn</label>
                <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="Ditt namn" required />
              </div>
              <div className="contact__field">
                <label>E-post</label>
                <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="Din e-post" required />
              </div>
            </div>
            <div className="contact__field">
              <label>Ämne</label>
              <input type="text" name="subject" value={form.subject} onChange={handleChange} placeholder="Vad gäller det?" />
            </div>
            <div className="contact__field">
              <label>Meddelande</label>
              <textarea name="message" value={form.message} onChange={handleChange} placeholder="Skriv ditt meddelande..." rows="5" required></textarea>
            </div>
            <button type="submit" className="contact__submit" disabled={status === 'sending'}>
              {status === 'sending' ? 'Skickar...' : 'Skicka meddelande'}
            </button>
            {status === 'success' && <p className="contact__status contact__status--success">Tack! Ditt meddelande har skickats.</p>}
            {status === 'error' && <p className="contact__status contact__status--error">Något gick fel. Försök igen.</p>}
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;
